import s from './style.module.css'

export function PageNotFound({props}){
    return <>
        404 - Page Not Found
    </>
}